<div class="wrapper">
  <div class="tooltip" #tooltipDiv *ngIf="lineTooltipInput != null">
    <div class="date">
      <img *ngIf="isPinned && (source === lineTooltipInput.type) && airNote != null &&
        airNote?.component === lineTooltipInput.type" src="assets/images/timeline/airnote-blue.png"/>
      {{lineTooltipInput.date | date:'H:mm, d MMM'}}
    </div>
    <div class="value-container">
      <span class="device-name">{{lineTooltipInput.selectedDevice.deviceName}}</span>
      <span style="margin-right: 8px;">: </span>
      <span
        style="font-weight: 700">{{lineTooltipInput.value | number: '1.1-1'}} </span>
      <span style="color:#ACB4BB">{{lineTooltipInput.type | sensorUnit: temperatureUnit}}</span>
    </div>
    <button *ngIf="isPinned && (source === lineTooltipInput.type)" [style.pointer-events]="'all'"
            class="air-note-btn" (click)="openAirNote()">
      <span *ngIf="!airNote || airNote?.component !== lineTooltipInput.type"><img
        src="assets/images/timeline/airnote.png" style="margin-left: 4px"/> Air Note</span>
      <span *ngIf="airNote && airNote?.component === lineTooltipInput.type">Edit</span>
    </button>
  </div>
  <div class="tail-background"></div>
  <img class="tooltip-tail" src="assets/images/timeline/tooltip-arrow.png"/>
</div>
